export default __webpack_public_path__ + "2c44723bde803b559d1afa48b080c2e0.svg";